export default __webpack_public_path__ + "static/media/history_3.440de7bf.png";